import OutlinesPanel from './OutlinesPanel';

export default OutlinesPanel;
